import React from 'react';
import { Outlet, Link } from 'react-router-dom';
import Navbar from '../../components/Navbar';

const AdminDashboard = () => {
  return (
    <div>
      <Navbar userRole="admin" />
      <div className="container">
        <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
          <h1>Panel de Administración</h1>
          <Link to="/admin/routes/designate" className="btn btn-primary" style={{ minWidth: '150px' }}>
            Designar Nueva Ruta
          </Link>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default AdminDashboard;
